export default __webpack_public_path__ + "static/logo-legend-79d22f21ee3fb30b8c41c22a70960bcb.png";